/**
 * Created by Rodrigo Quesada on 27/04/17.
 */
import {Injectable} from '@angular/core';
import _ = require('lodash');

let nextUniqueId = 0;

@Injectable()
export class PageStateService {

    private _unsavedState: { [key: number]: boolean } = {};

    reset() {
        this._unsavedState = {};
    }

    addUnsavedDataState(): number {
        const id = ++nextUniqueId;
        this._unsavedState[id] = true;
        return id;
    }

    removeUnsavedDataState(id: number): void {
        delete this._unsavedState[id];
    }

    unsavedDataPresent(): boolean {
        return !_.isEmpty(this._unsavedState);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/shared/services/page-state.service.ts